import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { testsetTargetsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_stacktrace/qa-operations-core/testset-targets/')({
  validateSearch: zodValidator(testsetTargetsSearchSchema)
});